import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { formatIQD, formatDateTime } from '../../../../shared/format.js';
import { refObject, refName, userName } from '../../helpers/refs.js';
import { useExpense } from '../../hooks/useExpense.js';

const METHOD_LABEL = {
  cash: 'نقدي',
  transfer: 'تحويل',
  external: 'خارجي'
};

const STATUS_LABEL = { recorded: 'مسجل', active: 'مسجل', cancelled: 'ملغي' };
const STATUS_TONE = { recorded: 'success', active: 'success', cancelled: 'danger' };

function Field({ label, children, wide }) {
  return (
    <div style={wide ? { gridColumn: '1 / -1' } : undefined}>
      <div className="text-[11px] font-semibold text-ink-3 mb-0.5">{label}</div>
      <div className="text-[13px] font-semibold text-ink">{children}</div>
    </div>
  );
}

export function ExpenseDetails({ expense, onClose }) {
  const id = expense ? expense._id || expense.id : null;
  const { data, isLoading } = useExpense(id);
  // بيانات الصف تُعرض فوراً، وتفاصيل الخادم تحلّ مكانها عند وصولها.
  const e = data || expense || {};
  const cat = refObject(e.category || e.categoryId);
  const method = e.paymentMethod || 'cash';
  const status = e.status || (e.cancelledAt ? 'cancelled' : 'recorded');

  if (!expense) return null;

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{ background: 'rgba(0,0,0,.5)' }}>
      <div className="card w-[520px] max-w-full max-h-[92vh] overflow-y-auto" onClick={(ev) => ev.stopPropagation()}>
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">تفاصيل المصروف</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        <div className="card-b space-y-3">
          <div className="flex items-baseline justify-between gap-3">
            <div className="text-[20px] font-extrabold" style={{ color: '#C2570D' }}>
              {formatIQD(e.amount || 0)}
            </div>
            <Pill variant={STATUS_TONE[status] || 'muted'}>{STATUS_LABEL[status] || status}</Pill>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-1">
            <Field label="التاريخ">{formatDateTime(e.date || e.createdAt) || '—'}</Field>
            <Field label="الفئة">
              <span className="inline-flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full flex-none" style={{ background: cat.color || '#FF7A1A' }} />
                {cat.name || '—'}
              </span>
            </Field>
            <Field label="طريقة الدفع">{METHOD_LABEL[method] || method}</Field>
            <Field label="اسم القاصة">{refName(e.cashbox || e.cashboxId)}</Field>
            <Field label="مُنفّذ العملية">{userName(e.createdBy || e.createdById)}</Field>
            <Field label="المورّد">{e.supplierName || '—'}</Field>
            <Field label="الوصف" wide>{e.description || '—'}</Field>
            <Field label="ملاحظات" wide>{e.notes || '—'}</Field>
            {status === 'cancelled' ? (
              <>
                <Field label="مُلغي العملية">{userName(e.cancelledBy || e.cancelledById)}</Field>
                <Field label="وقت الإلغاء">{formatDateTime(e.cancelledAt) || '—'}</Field>
                <Field label="سبب الإلغاء" wide>{e.cancelReason || '—'}</Field>
              </>
            ) : null}
          </div>

          {isLoading ? <div className="text-[12px] text-ink-3">جاري تحميل التفاصيل...</div> : null}
        </div>

        <div className="card-h border-t border-b-0 flex justify-end gap-2">
          <button type="button" className="btn btn-primary" onClick={onClose}>إغلاق</button>
        </div>
      </div>
    </div>
  );
}
